import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { useParams } from 'react-router';
import { routes } from 'routes/routes';
import { ProjectSideBar } from 'views/navigation/project-side-bar/project-side-bar';
import { ActivityModel } from 'views/activity-model/activity-model';
import { Risks } from 'views/risks/risks';
import { CostSetup } from 'views/cost-setup/cost-setup';
import { NotFound } from 'views/not-found/not-found';
import ResultOverview from 'views/simulations/result-overview/result-overview';
import { Statistics } from 'views/simulations/statistics/statistics';
import { Overview } from 'views/overview/overview';
import { TimeTracker } from 'views/time-tracker/time-tracker';
import { CostTracker } from 'views/cost-tracker/cost-tracker';
import { WellDetails } from 'views/well-details/well-details';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { getEstimate } from 'store/entities/projects/projects';
import { selectSubjectId } from 'store/entities/authorization/selectors';
import { validateEstimateAccess } from 'client/common/access-control/estimate-access-validator';

const RawProject = ({ getEstimate, estimate, currentUserId }) => {
  const { project } = useParams();
  useEffect(() => {
    getEstimate(project);
  }, [project]);
  const isEstimateAccessible = estimate ? !validateEstimateAccess(currentUserId, estimate) : false;

  return (
    <>
      <ProjectSideBar />
      <Routes>
        <Route {...routes.activityModel.pattern} element={<ActivityModel isPageDisabled={isEstimateAccessible} />} />
        <Route
          {...routes.risks.pattern}
          element={<Risks projectId={project} isPageDisabled={isEstimateAccessible} />}
        />
        <Route {...routes.costSetup.pattern} element={<CostSetup isPageDisabled={isEstimateAccessible} />} />
        <Route
          {...routes.resultOverview.pattern}
          element={<ResultOverview projectId={project} isPageDisabled={isEstimateAccessible} />}
        />
        <Route {...routes.statistics.pattern} element={<Statistics projectId={project} />} />
        <Route {...routes.overview.pattern} element={<Overview isPageDisabled={isEstimateAccessible} />} />
        <Route {...routes.timeTracker.pattern} element={<TimeTracker isPageDisabled={isEstimateAccessible} />} />
        <Route {...routes.costTracker.pattern} element={<CostTracker isPageDisabled={isEstimateAccessible} />} />
        <Route {...routes.wellConfiguration.pattern} element={<WellDetails isPageDisabled={isEstimateAccessible} />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

const mapStateToProps = ({ entities }) => {
  const {
    projects: { estimate },
  } = entities;

  return { estimate, currentUserId: selectSubjectId(entities) };
};

const mapDispatchToProps = { getEstimate };

const Container = withErrorBoundary(connect(mapStateToProps, mapDispatchToProps)(RawProject), {
  style: { position: 'absolute', top: '50px' },
});

export { Container as Project };
